import React from "react";
import AcquireWebComponent from "../framework/MaterialUI";
import { isEmpty } from "lodash";

const google = window.google;
const deck = window.deck;

const COLOR_RANGE = [
  [32, 43, 223, 0],
  [31, 31, 223],
  [223, 31, 223],
  [223, 31, 31],
  [223, 223, 31],
];

class HeatMap extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = { showLoadingDialog: false };
    this.map = null;
    this.overlay = null;
  }

  componentDidMount() {
    const { pointsData } = this.props;

    if (isEmpty(pointsData)) return;
    const INITIAL_CENTER = { lat: 42.87, lng: -97.38 };

    this.map = new google.maps.Map(document.getElementById("map-canvas"), {
      zoom: 4,
      maxZoom: 9,
      minZoom: 4,
      center: INITIAL_CENTER,
      mapTypeId: "roadmap",
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
    });

    this.overlay = new deck.GoogleMapsOverlay({
      layers: [this.buildHeatmapLayer()],
    });
    this.overlay.setMap(this.map);
  }

  componentWillUnmount() {
    if (this.overlay) {
      this.overlay.setMap(null);
      this.overlay = null;
    }
  }

  buildHeatmapLayer() {
    return new deck.HeatmapLayer({
      id: "insights-heatmap",
      data: this.props.pointsData,
      getPosition: d => d.position,
      getWeight: d => d.weight,
      radiusPixels: 80,
      intensity: 2,
      threshold: 0.03,
      colorRange: COLOR_RANGE,
      aggregation: "SUM",
    });
  }

  render() {
    const { title, height, pointsData, onLoading } = this.props;
    if (onLoading) {
      return (
        <div
          style={{
            float: "left",
            height: "200px",
            width: "100%",
            position: "relative",
            padding: "20px",
          }}
        >
          <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
          &nbsp;loading...
        </div>
      );
    }
    if (isEmpty(pointsData)) {
      return (
        <div
          style={{
            float: "left",
            height: "200px",
            width: "100%",
            position: "relative",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "100%",
              minHeight: "200px",
              textAlign: "center",
              paddingTop: "60px",
              color: "#CDCDCD",
            }}
          >
            <div style={{ color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" }}>
              No Data
            </div>
          </div>
        </div>
      );
    }
    return (
      <div
        className="mb-20"
        style={{ /*height: "100%", */ position: "relative" }}
      >
        {this.state.showLoadingDialog && (
          <div className="map-loading-modal">
            <div>Map data loading, please wait...</div>
          </div>
        )}

        <div
          style={{ fontSize: "24px", marginBottom: "20px", fontWeight: "bold" }}
        >
          {title}
        </div>
        <div id="map-canvas" style={{ height: height + "px" }}></div>
        <div style={{ width: "100%", margin: "10px 20px", height: "40px" }}>
          <div className="text-center mt-10 mb-5">
            <strong>Heat Map Density Scale</strong>
          </div>
          <div
            id="map_legend"
            className="heatmap-legend"
            style={{ width: "60%", margin: "0", border: "solid 1px black" }}
          >
            &nbsp;
          </div>
          <div
            className="mt-5 mb-10"
            style={{ width: "60%", marginLeft: "20%", fontWeight: "350" }}
          >
            <div className="pull-left">Low</div>
            <div className="pull-right">High</div>
            <div className="text-center">Medium</div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeatMap;



// WEBPACK FOOTER //
// ./src/components/Insights/HeatMap.jsx